import type { GridColDef } from '@mui/x-data-grid';
import type { Customer } from '@vy/types';
import { compareDatesDescending, formatDate } from '../../../../../utils/date';

export const ANONYMOUS_CUSTOMER_COLUMN_KEYS = Object.freeze({
  NAME: 'name',
  EXTERNAL_ID: 'externalId',
  CREATED_AT: 'createdAt',
} satisfies Record<string, keyof Customer>);

export const ANONYMOUS_CUSTOMERS_COLUMNS: GridColDef<Customer>[] = [
  {
    field: ANONYMOUS_CUSTOMER_COLUMN_KEYS.EXTERNAL_ID,
    headerName: 'External ID',
    headerClassName: 'text-sm',
    headerAlign: 'left',
    align: 'left',
    cellClassName: 'pl-10',
    width: 160,
    valueGetter: (_value, row) => row.externalId ?? '--',
  },
  {
    field: ANONYMOUS_CUSTOMER_COLUMN_KEYS.NAME,
    headerName: 'Name',
    headerClassName: 'text-sm',
    flex: 1,
    headerAlign: 'left',
    align: 'left',
    valueGetter: (_value, row) => row.name,
  },
  {
    field: ANONYMOUS_CUSTOMER_COLUMN_KEYS.CREATED_AT,
    headerName: 'Created at',
    headerClassName: 'text-sm',
    flex: 1,
    width: 400,
    headerAlign: 'left',
    align: 'left',
    renderCell: ({ row }) => formatDate(row.createdAt),
    sortComparator: (firstDate, secondDate) => compareDatesDescending(firstDate, secondDate),
  },
];
